<template lang="pug">
v-app
  template(v-if="!loading")
    main-header(v-if="$route.path !== '/error404'")
    v-main
      router-view
    main-footer(v-if="$route.path !== '/error404'")
  v-sheet.d-flex.justify-center.align-center(
    v-else,
    height="100%",
    width="100%",
    color="transparent"
  )
    v-progress-circular(:size="50", color="primary", indeterminate)
</template>

<script>
import MainHeader from "@/components/shell/main-header/Index.vue";
import MainFooter from "@/components/shell/MainFooter.vue";

export default {
  data: () => ({
    loading: true,
  }),
  beforeCreate() {
    this.$rest("informations")
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    tel() {
      return this.$rest("informations").item.whatsapp;
    },
    name() {
      const name = this.$rest("informations").item.name;
      return name ? name : "";
    },
  },
  watch: {
    name() {
      document.title =
        (!["/"].includes(this.$route.path) ? this.$route.name + " - " : "") + this.name;
    },
    $route() {
      document.title =
        (!["/"].includes(this.$route.path) ? this.$route.name + " - " : "") + this.name;
    },
  },
  created() {
    document.title =
      (!["/"].includes(this.$route.path) ? this.$route.name + " - " : "") + this.name;
  },
  components: {
    MainHeader,
    MainFooter,
  },
};
</script>

<style>
@import "./style/main.css";
@import "./style/custom-user.css";
@import "./style/custom-vuetify.css";
</style>
